import { createContext } from '@direct-frontend/modules-context';
import type { MyStoreApiLinkStoreStatus } from '../../api/schema';

export interface StoresRequestContextStore {
    id: string;
    name: string;
    slug: string;
    status: MyStoreApiLinkStoreStatus;
    b2bHost: string;
}

/**
 * Отдельный контекст для использования на страницах, связанных с регистрацией магазинов
 *
 * Смысл в том, что параметры контекста не доступны в остальной части приложения, поэтому целесообразно изолировать их здесь,
 * а не выносить опциональными в общий контекст.
 *
 * Чтобы не было соблазна заиспользовать их в остальной части приложения.
 */
export interface StoresRequestContext {
    /**
     * Почта из Яндекс ID, если пользователь авторизован, используется в форме для регистрации магазинов
     */
    email?: string;

    /**
     * Тип магазинов в зависимости от домена и роута
     * * Kit - китовый домен && роуты /stores и /stores/new
     * * Lite - ycp домен && роуты /stores/lite и /stores/lite/new
     * * ExternalCheckout (YCP | Bitrix) - ycp домен && роуты /stores и /stores/new (в деве роуты /stores/checkouts и /stores/checkouts/new)
     */
    storesType: 'Kit' | 'Lite' | 'ExternalCheckout';

    /**
     * Созданные магазины пользователя
     */
    stores: {
        total_count: number;
        items: StoresRequestContextStore[];
    };
}

export const { setContext: setStoresRequestContext, getContext: getStoresRequestContext } =
    createContext<StoresRequestContext>({
        name: 'storesRequestContext',
    });

export const getSafeStoresRequestContext = (): StoresRequestContext => {
    try {
        return getStoresRequestContext();
    } catch (_) {
        return {
            email: '',
            storesType: 'Kit',
            stores: {
                total_count: 0,
                items: [],
            },
        };
    }
};
